import ArrowLeft from "../../../assets/Chevron/ArrowLeft_White.svg";

export type HeaderProps = {
  title?: string;
};

export function SimpleHeader({ title }: HeaderProps) {
  return (
    <>
      <div className="bg-brandBlue h-[70px] w-full relative">
        {/* Inner content container stays centered and responsive */}
        <div
          className="mx-auto content-center flex flex-wrap gap-[var(--sds-size-space-600,0px_24px)] h-full items-center p-[var(--sds-size-space-400,16px)] relative max-w-[440px]"
          data-name="Header"
          data-node-id="1374:18993"
        >
          <div
            className="absolute content-stretch flex gap-[4px] items-center justify-center left-1/2 top-[calc(50%+0.5px)] translate-x-[-50%] translate-y-[-50%] w-[300px]"
            data-name="Block"
            data-node-id="1191:25692"
          >
            <p
              className="font-['Noto_Sans_CJK_JP:Medium',sans-serif] leading-none not-italic relative shrink-0 text-[18px] text-brandOnBrandText"
              data-node-id="1191:25695"
            >
              {title ?? "SASオンラインクリニック"}
            </p>
          </div>
        </div>
        {/* Fixed edges: left arrow and right menu aligned to header edges */}
        <button
          type="button"
          onClick={() => {
            if (typeof window !== "undefined") {
              if (window.history.length > 1) {
                window.history.back();
              } else {
                window.location.assign("/patient/home");
              }
            }
          }}
          className="absolute left-[16px] overflow-clip size-[30px] top-[20px]"
          data-name="Arrow left"
          data-node-id="1374:19461"
          aria-label="戻る"
        >
          <img
            alt="戻る"
            className="block max-w-none size-full"
            src={ArrowLeft}
          />
        </button>
      </div>
    </>
  );
}
